export const OPEN_BULK_UPDATE_DIALOG = "OPEN_BULK_UPDATE_DIALOG"
export const CLOSE_BULK_UPDATE_DIALOG = "CLOSE_BULK_UPDATE_DIALOG"

export const CHANGE_SELECTED_ORDER = "CHANGE_SELECTED_ORDER"
const INITIAL_STATE = {
  isBulkDialogOpen: false,
  selectedOrder: null,
}

export function orderReducer(state = INITIAL_STATE, { type, payload }) {
  switch (type) {
    case OPEN_BULK_UPDATE_DIALOG:
      return {
        ...state,
        isBulkDialogOpen: true,
        selectedOrder: payload,
      }
    case CLOSE_BULK_UPDATE_DIALOG:
      return {
        ...state,
        isBulkDialogOpen: false,
        selectedOrder: null,
      }

    case CHANGE_SELECTED_ORDER:
      return {
        ...state,
        selectedOrder: payload,
      }

    default:
      return state
  }
}
